export default __webpack_public_path__ + "static/media/utensils-solid.52b144f9.svg";